import { useEffect, useState } from "react"
import { Redirect } from "react-router-dom"
import history from "../history"

const Random = () => {
    const [id, setId] = useState(null)

    useEffect(() => {
        fetch("/api/catalog/random")
            .then(r => r.json())
            .then(data => {
                if (data && data.id) setId(data.id)
                else history.push("/catalog")
            })
    }, [])

    return id ? <Redirect to={`/catalog/item/${id}`} /> : null
}

export default Random
